import React, { useEffect } from 'react'
import {
	CopyrightAgentLoader,
	Modal,
	ModalSection,
	PrimaryButton,
	Row,
	SearchInput,
	Typography,
} from '@copyrightagent/basic-components'
import { Button } from '@material-ui/core'
import globalUseStyle from '../../routes/Private/RegistrationCertificates/style'
import useStyle from './SelectRegistrationCertificateModalStyle'
import clsx from 'clsx'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useRegistrationCertificatesStore } from '../../routes/Private/RegistrationCertificates/stores/registrationCertificateStore'
import { toast } from '../../store/utils'
import { uploadRegisteredImages } from '../../routes/Private/RegistrationCertificates/api'
import { useRegistrationCertificateStore } from './registrationCertificateStore'

export const SelectRegistrationCertificateModal = ({
	partnerImageId,
}: {
	partnerImageId: string
}) => {
	const {
		selectRegistrationCertificateModalOpened,
		setSelectRegistrationCertificateModalOpened,
		setRegistrationCertificate,
	} = useRegistrationCertificateStore()

	const {
		fetchRegistrationCertificates,
		registrationCertificates,
		totalRegistrationCertificatesCount,
		setSearchString,
		searchString,
		setUploadCertificateModalOpen,
	} = useRegistrationCertificatesStore()

	const globalClasses = globalUseStyle()
	const classes = useStyle()

	const handleSearch = async () => {
		fetchRegistrationCertificates({
			isInitialLoad: true,
		})
	}

	useEffect(() => {
		fetchRegistrationCertificates({
			isInitialLoad: true,
		})
	}, [])

	const selectRegistrationCertificate = async ({
		registrationCertificateId,
		registrationCertificateNumber,
	}: {
		registrationCertificateId: string
		registrationCertificateNumber: string
	}) => {
		toast('Attaching image to registration certificate', 'info')
		const response = await uploadRegisteredImages({
			partnerImageIds: [partnerImageId],
			registrationCertificateId,
		})
		if (response.isSuccessful) {
			setSelectRegistrationCertificateModalOpened(false)
			setRegistrationCertificate({
				registrationCertificateId,
				registrationCertificateNumber,
			})
			await toast(
				'Successfully attached image to registration certificate',
				'success',
			)
		} else {
			await toast(
				'Failed to attached image to registration certificate',
				'error',
			)
		}
	}

	return (
		<Modal
			open={selectRegistrationCertificateModalOpened}
			onClose={() => setSelectRegistrationCertificateModalOpened(false)}
			title={`Select Registration Certificate`}
			titleText={
				'Attach this image to a registration certificate by selecting from the list below'
			}
			size="large"
		>
			<ModalSection>
				<div className={classes.modalContentContainer}>
					<div className={globalClasses.searchContainer}>
						<SearchInput
							value={searchString}
							onChange={(e) => setSearchString(e.target.value)}
							placeholder={'Search for Registration Certificate'}
						/>
						<PrimaryButton
							style={{ marginLeft: '16px' }}
							text={'Search'}
							onClick={handleSearch}
						/>
					</div>
					<div
						id="modalRegistrationCertificatesList"
						className={globalClasses.listContainer}
						style={{
							maxHeight: '500px',
						}}
					>
						<InfiniteScroll
							className={globalClasses.infiniteScrollWrap}
							dataLength={registrationCertificates.length}
							next={fetchRegistrationCertificates}
							hasMore={
								registrationCertificates.length <
								totalRegistrationCertificatesCount
							}
							loader={
								<div key={0} className={globalClasses.loadingContainer}>
									<CopyrightAgentLoader />
								</div>
							}
							scrollableTarget="modalRegistrationCertificatesList"
						>
							{registrationCertificates.map(
								(registrationCertificate, index) => (
									<Row justify="flex-start" key={index}>
										<div
											className={clsx(globalClasses.card)}
											onClick={() =>
												selectRegistrationCertificate({
													registrationCertificateId:
														registrationCertificate.registration_certificate_id,
													registrationCertificateNumber:
														registrationCertificate.registration_certificate_number,
												})
											}
											style={{ display: 'flex' }}
										>
											<div
												className={globalClasses.containerWithChip}
												style={{ flex: 1 }}
											>
												<div>
													<div>
														<Typography
															variant="body2"
															fontColor="rgb(142, 147, 155)"
														>
															Registration Certificate Number
														</Typography>
														<Typography variant="body2">
															{
																registrationCertificate.registration_certificate_number
															}
														</Typography>
													</div>
												</div>
											</div>

											<div className={globalClasses.rowDivider} />
											<div
												className={globalClasses.containerWithChip}
												style={{ flex: 1 }}
											>
												<div>
													<Typography
														variant="body2"
														fontColor="rgb(142, 147, 155)"
													>
														Effective Date
													</Typography>
													<Typography variant="body2">
														{
															registrationCertificate.effective_registration_date
														}
													</Typography>
												</div>
											</div>
										</div>
									</Row>
								),
							)}
						</InfiniteScroll>
					</div>
				</div>
			</ModalSection>
			<ModalSection>
				<Row justify="flex-end">
					<Button
						className={globalClasses.invisibleButton}
						onClick={() => setSelectRegistrationCertificateModalOpened(false)}
					>
						<Typography>Cancel</Typography>
					</Button>
					<PrimaryButton
						type="submit"
						// loading={uploading}
						text={'Upload New Certificate'}
						loadingText={'Uploading Image IDs'}
						onClick={() => {
							setSelectRegistrationCertificateModalOpened(false)
							setUploadCertificateModalOpen(true)
						}}
					/>
				</Row>
			</ModalSection>
		</Modal>
	)
}
